import React from "react";

const ParameterTable = ({ parameters }) => {
  if (!parameters || parameters.length === 0) return null;

  const pathParams = parameters.filter((p) => p.location === "path");
  const queryParams = parameters.filter((p) => p.location === "query");
  const bodyParams = parameters.filter((p) => p.location === "body");
  const headerParams = parameters.filter((p) => p.location === "header");

  const renderGroup = (title, params) => {
    if (params.length === 0) return null;

    return (
      <div className="api-docs-param-group">
        <h4 className="api-docs-param-group-title">{title}</h4>
        <table className="api-docs-param-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Required</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {params.map((param) => (
              <tr key={param.name}>
                <td className="api-docs-param-name">
                  {param.name}
                  {param.example !== undefined && (
                    <span className="api-docs-param-example">
                      e.g. <code>{String(param.example)}</code>
                    </span>
                  )}
                </td>
                <td className="api-docs-param-type">{param.type}</td>
                <td>
                  {param.required ? (
                    <span className="api-docs-param-required">required</span>
                  ) : (
                    <span className="api-docs-param-optional">optional</span>
                  )}
                </td>
                <td>{param.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="api-docs-parameters">
      <h3>Parameters</h3>
      {renderGroup("Path Parameters", pathParams)}
      {renderGroup("Query Parameters", queryParams)}
      {renderGroup("Body Parameters", bodyParams)}
      {renderGroup("Header Parameters", headerParams)}
    </div>
  );
};

export default ParameterTable;
